/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2021 Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import Page from 'flarum/common/components/Page';
import SignUpModal from 'flarum/forum/components/SignUpModal';
import type { AuthSuccessCallbacks } from './loginExtender';

/**
 * Parameters accepted by the Google Marketing Platform conversion events fired below.
 */
export interface GtagConversionParams {
	allow_custom_scripts: boolean;
	u30: string;
	u31: string;
	u32: string;
	u33: string;
	u34: string;
	send_to: string;
}

declare global {
	/**
	 * Google's global site tag. Injected by the tag manager snippet, which is not
	 * always present — every call site below is guarded by a `try`/`catch`.
	 */
	function gtag(command: 'event', action: string, params: GtagConversionParams): void;

	/**
	 * Google Analytics' classic command queue. Also injected externally and
	 * therefore optional at runtime.
	 */
	function ga(command: string, ...fields: unknown[]): void;
}

export default function () {
	extend(SignUpModal.prototype, 'onSignUpSuccessCallbacks', function (callbacks: AuthSuccessCallbacks) {
		callbacks.add('of-gtag-event', () => {
			// Send Google Tag Event
			try {
				gtag('event', 'conversion', {
					allow_custom_scripts: true,
					u30: '[user.device]',
					u31: '[user.alter]',
					u32: '[user.geschlecht]',
					u33: '[user.plz]',
					u34: '[user.ort]',
					send_to: 'DC-9327407/bookc0/bookc0+standard',
				});
			} catch (error) {}
		});
	});

	extend(Page.prototype, 'oninit', function () {
		try {
			gtag('event', 'conversion', {
				allow_custom_scripts: true,
				u30: '[user.device]',
				u31: '[user.alter]',
				u32: '[user.geschlecht]',
				u33: '[user.plz]',
				u34: '[user.ort]',
				send_to: 'DC-9327407/bookc0/bookc00+standard',
			});
		} catch (e) {
			if (e instanceof ReferenceError) {
				// console.warn('gtag is not available');
			} else {
				// console.error(e);
			}
		}
		try {
			ga('set', 'page', m.route.get());
			ga('send', 'pageview');
		} catch (e) {
			if (e instanceof ReferenceError) {
				// console.warn('ga is not available');
			} else {
				// console.error(e);
			}
		}
	});
}
